import { lazy, Suspense, useEffect } from "react";
import { Route, HashRouter as Router, Routes, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { ColorBlindModeProvider } from "./context/ColorBlindModeContext";
import GunCursor from "./easter_eggs/GunCursor";
import Home, { SECTIONS } from "./home/Home";

const CalendarPuzzle = lazy(() => import("./calendar_puzzle/CalendarPuzzle.tsx"));
const Game4096 = lazy(() => import("./4096/Game4096.tsx"));
const Dendrites = lazy(() => import("./dendrites/Dendrites.tsx"));
const GameOfLife = lazy(() => import("./game_of_life/GameOfLife.tsx"));
const LavaLamp = lazy(() => import("./lava_lamp/LavaLamp.tsx"));
const MatchGame = lazy(() => import("./match_game/MatchGame"));
const Wip = lazy(() => import("./projects/Wip"));
const Shavianator = lazy(() => import("./shavianator/Shavianator"));
const Shufflenator = lazy(() => import("./shufflenator/Shufflenator"));
const Snek = lazy(() => import("./snek/Snek"));
const Sudoku = lazy(() => import("./sudoku/Sudoku"));
const MonarchMusic = lazy(() => import("./monarch_music/MonarchMusic"));
const OuraHr = lazy(() => import("./oura_hr/OuraHr.js"));
const Toolbox = lazy(() => import("./toolbox/Toolbox.js"));
const WarOfTheDice = lazy(() => import("./war_of_the_dice/WarOfTheDice.tsx"));
const Weather = lazy(() => import("./weather/Weather.js"));

function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const pageName = path === "/" ? "home" : path.substring(1);
    document.title = `connor.${pageName}`;
  }, [location]);

  return null;
}

function App() {
  return (
    <ColorBlindModeProvider>
      <Router>
        <TitleUpdater />
        <GunCursor />
        <Navbar />
        <Suspense
          fallback={
            <div className="loading-container"/>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            {SECTIONS.map(({ slug }) => (
              <Route key={slug} path={`/${slug}`} element={<Home />} />
            ))}
            <Route path="/snek" element={<Snek />} />
            <Route path="/wip" element={<Wip />} />
            <Route path="/sudoku" element={<Sudoku />} />
            <Route path="/matchgame" element={<MatchGame />} />
            <Route path="/shufflenator" element={<Shufflenator />} />
            <Route path="/shavianator" element={<Shavianator />} />
            <Route path="/game-of-life" element={<GameOfLife />} />
            <Route path="/lava-lamp-radio" element={<LavaLamp />} />
            <Route path="/dendrites" element={<Dendrites />} />
            <Route path="/4096" element={<Game4096 />} />
            <Route path="/monarch-music" element={<MonarchMusic />} />
            <Route path="/war-of-the-dice" element={<WarOfTheDice />} />
            <Route path="/weather" element={<Weather />} />
            <Route path="/oura-hr" element={<OuraHr />} />
            <Route path="/calendar-puzzle" element={<CalendarPuzzle />} />
            <Route path="toolbox" element={<Toolbox />} />
          </Routes>
        </Suspense>
        <Footer />
      </Router>
    </ColorBlindModeProvider>
  );
}

export default App;
